module.exports = __webpack_public_path__ + "static/media/dark2.3268c99d.JPG";